import React from 'react';
import {
    formatter, formatterDecimal
} from "../../../../../utils/common";

const Widget = ({ textColorClass, value, label, isShowSale, saleAmount, isShowReturn, returnAmount }) => {
    textColorClass = textColorClass ? textColorClass : 'text-dark';
    return (
        <div className="col-md-6 col-xl" style={{ padding: 6 }}>
            <div className="summary-box">
                <div className="summary-box-body text-right">
                    <h6 className="text-truncate sb-title">{label}</h6>
                    <h5 className={`sm-value ${textColorClass}`}>{value}</h5>
                </div>

                {(isShowSale || isShowReturn) && (
                    <div className="summary-box-footer">
                        {isShowSale ? (
                            <div className="sbf-item sbf-item-left text-center">
                                <small className="text-muted">Sale</small>
                                <div className="font-weight-bold">{saleAmount}</div>
                            </div>
                        ) : null}

                        {isShowReturn ? (
                            <div className="sbf-item sbf-item-right text-center">
                                <small className="text-muted">Return</small>
                                <div className="font-weight-bold">{returnAmount}</div>
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
};


const ShopifyPayoutDetailsSummary = ({ payoutReportState }) => {
    const totalRow = payoutReportState.shopifyPayoutDetailTableRow;
    const totalSummary = payoutReportState.shopifyPayoutDetailTotalSummary;

    const totalSale = Number(totalSummary?.total_charge_amount || 0);
    const totalReturn = Number(totalSummary?.total_refund_amount || 0);
    const totalSaleFees = Number(totalSummary?.total_charge_fee || 0);
    const totalReturnFees = Number(totalSummary?.total_refund_fee || 0);
    const totalNetSale = totalSale - totalSaleFees;
    const totalNetReturn = totalReturn - totalReturnFees;

    const widgetsData = [
        {
            value: totalRow,
            label: "Total Records",
        },
        {
            // textColorClass: 'text-success',
            value: formatter.format(totalSale + totalReturn),
            label: "Total Gross",
            isShowSale: true,
            saleAmount: formatter.format(totalSale),
            isShowReturn: true,
            returnAmount: formatter.format(totalReturn),
        },
        {
            value: formatter.format((0 - totalSaleFees) + (0 - totalReturnFees)),
            label: "Total Fees",
            isShowSale: true,
            saleAmount: formatter.format(0 - totalSaleFees),
            isShowReturn: true,
            returnAmount: formatter.format(0 - totalReturnFees),
        },
        {
            value: formatter.format(totalNetSale + totalNetReturn),
            label: "Total Net",
            // isShowSale: true,
            // saleAmount: formatter.format(totalNetSale),
            // isShowReturn: true,
            // returnAmount: formatter.format(totalNetReturn),
        },
        // {
        //     textColorClass: 'text-danger',
        //     value: formatter.format(totalSaleFees + totalReturnFees),
        //     label: "Difference with Shopify",
        // },
    ];

    return (
        <div className="row" style={{ marginLeft: -6, marginRight: -6 }}>
            {widgetsData.map((widget, index) => (
                <Widget
                    key={index}
                    textColorClass={widget.textColorClass}
                    value={widget.value}
                    label={widget.label}
                    isShowSale={widget.isShowSale}
                    saleAmount={widget.saleAmount}
                    isShowReturn={widget.isShowReturn}
                    returnAmount={widget.returnAmount}
                />
            ))}
        </div>
    );
};

export default ShopifyPayoutDetailsSummary;
